'use client';

import { Suspense, type ReactNode } from 'react';
import { ListingNavigationProvider } from '@/components/ListingNavigationProvider';

/** Wraps listing routes; Suspense is required for useSearchParams in child trees. */
export function ListingNavigationShell({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={null}>
      <ListingNavigationProvider>{children}</ListingNavigationProvider>
    </Suspense>
  );
}
